import axios from "axios";
import { createBrowserHistory } from "history";

const jwtToken = sessionStorage.getItem("jwtToken");
const token = sessionStorage.getItem("token");
sessionStorage.setItem("peer_insurer", "peer0.insurer-net");
const peer = sessionStorage.getItem("peer");
const peer_insurer = "peer0.insurer-net";
const peers = sessionStorage.getItem("peers");
const factor_peer = "peer0.factor-net";
const userid = sessionStorage.getItem("user_id");
const LimaPeer = "peer1.trustee.trurep.testing.emulya.com";
const role = "trustee";
const saludaPeer = sessionStorage.getItem("peer");
const ChannelName = sessionStorage.getItem("ChannelName");

export const history = createBrowserHistory();

export const API = axios.create({
  baseURL: process.env.react_app_base_url + "backendapiwsfs/",
});

// Attach auth headers on every request if available
API.interceptors.request.use((config) => {
  const bearer = sessionStorage.getItem('jwtToken');
  const cluster = sessionStorage.getItem('token');
  if (!config.headers) config.headers = {};
  if (bearer) config.headers['authorization'] = `Bearer ${bearer}`;
  if (cluster) config.headers['clustertoken'] = `${cluster}`;
  return config;
});

API.interceptors.response.use(
  (response) => {
    // console.log("response", response);
    if (response.data.token == -1) {
      alert("Token expired, please login again!");
      window.location.href = "/";
    } else {
      return response;
    }
  },
  (error) => {
    console.log("error", JSON.stringify(error));
    if (!error.response) {
      console.log("Interceptor - Server is not running");
      // window.location.href = "/server-down";
    } else if (error.response.status === 401) {
      console.log(
        "Interceptor - 401 - Unauthorized: Token Invalid, please login again"
      );
      // alert("Token Missing!")
      sessionStorage.clear();
      window.location.assign("/");
    } else if (error.response.status === 400) {
      console.log("Interceptor - 400" + error.response.data.messages);
      // window.location.href = "/";
      alert("Missing Arguments!");
      return Promise.reject(error.response) || null;
    } else if (error.response.status === 503) {
      console.log("Interceptor - 503" + error.response.data.messages);
      alert("503 service unavailable");
      return null;
    } else if (error.response.status === 504) {
      console.log("Interceptor - 504" + error.response.data.messages);
      alert("504 Gateway Timeout");
      return null;
    } else if (error.response.status === 422) {
      console.log("Interceptor - 422" + error.response.data.messages);
      return error;
    } else if (error.response.status === 404) {
      console.log("Interceptor - 404" + error.response.data.messages);
      return error;
    } else if (error.response.status === 500) {
      console.log("Interceptor - 500" + error.response.data.messages);
      alert("Internal Server Error");
      return error;
    } else {
      return Promise.reject(error);
    }
  }
);

const determinePlatformName = () => {
  switch (process.env.react_app_base_url) {
    case "https://wilmington.intainadmin.com/":
      return "WilmingTon";
    case "https://demo.intainadmin.com/":
      return "Demo";
    case "https://iauat.intainadmin.com/":
      return "IA_UAT";
    case "https://wsfs.intainabs.com/":
      return "WSFS";
    default:
      return "CreditFacility";
  }
};

const getAskAiBaseUrl = () => {
  const base =
    "https://analytics.wsfs.intainabs.com/";
  return String(base).endsWith("/") ? String(base) : `${base}/`;
};

const buildAskStratHeaders = () => ({
  authorization: `Bearer ${sessionStorage.getItem("jwtToken") || token || ""}`,
  platformname: determinePlatformName(),
  channelname: sessionStorage.getItem("ChannelName") || ChannelName,
  clientname: determinePlatformName(),
  clustertoken: `${sessionStorage.getItem("token") || token || ""}`,
});

export const authenticate = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  console.log("authenticate data", data);
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/authenticate",
    data,
    { headers: headers }
  );
  return response;
};

export const registerUser = async (UserRole, data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  let response = null;
  if (UserRole == "trustee") {
    response = await API.post(
      process.env.react_app_base_url + "backendapiwsfs/registerUser",
      data,
      { headers: headers }
    );
    return response;
  } else if (UserRole == "servicer") {
    response = await API.post(
      process.env.react_app_base_url + "backendapiwsfs/registerUser",
      data,
      { headers: headers }
    );
    return response;
  } else if (UserRole == "investor") {
    response = await API.post(
      process.env.react_app_base_url + "backendapiwsfs/registerUser",
      data,
      { headers: headers }
    );
    return response;
  } else if (UserRole == "investor2") {
    response = await API.post(
      process.env.react_app_base_url + "backendapiwsfs/registerUser",
      data,
      { headers: headers }
    );
    return response;
  } else if (UserRole == "investor3") {
    response = await API.post(
      process.env.react_app_base_url + "backendapiwsfs/registerUser",
      data,
      { headers: headers }
    );
    return response;
  }
};



export const getAllUserRoles = async () => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url + "backendapiwsfs/getAllUserRoles",
    { headers: headers }
  );
  return response;
};

export const getuserByOrgname = async (OrgName) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  console.log("OrgName", OrgName);
  if (OrgName == "trustee") {
    const response = await API.get(
      process.env.react_app_base_url +
        "backendapiwsfs/getUserByOrgName?OrgName=" +
        OrgName +
        "&peer=" +
        peer,
      { headers: headers }
    );
    return response;
  } else if (OrgName == "servicer") {
    const response = await API.get(
      process.env.react_app_base_url +
        "backendapiwsfs/getUserByOrgName?OrgName=" +
        OrgName +
        "&peer=" +
        peer,
      { headers: headers }
    );
    return response;
  } else if (OrgName == "investor") {
    const response = await API.get(
      process.env.react_app_base_url +
        "backendapiwsfs/getUserByOrgName?OrgName=" +
        OrgName +
        "&peer=" +
        peer,
        { headers: headers }
    );
    return response;
  } else if (OrgName == "investor2") {
    const response = await API.get(
      process.env.react_app_base_url +
        "backendapiwsfs/getUserByOrgName?OrgName=" +
        OrgName +
        "&peer=" +
        peer,
      { headers: headers }
    );
    return response;
  } else if (OrgName == "investor3") {
    const response = await API.get(
      process.env.react_app_base_url +
        "backendapiwsfs/getUserByOrgName?OrgName=" +
        OrgName +
        "&peer=" +
        peer,
      { headers: headers }
    );
    return response;
  }
};

export const approveUser = async (OrgName, data) => {
  let response = null;
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
  };
  if (OrgName == "trustee") {
    response = await API.post(
      process.env.react_app_base_url + "backendapiwsfs/approveUser",
      data,
      { headers: headers }
    );
    return response;
  } else if (OrgName == "servicer") {
    response = await API.post(
      process.env.react_app_base_url + "backendapiwsfs/approveUser",
      data,
      { headers: headers }
    );
    return response;
  } else if (OrgName == "investor") {
    response = await API.post(
      process.env.react_app_base_url + "backendapiwsfs/approveUser",
      data,
      { headers: headers }
    );
    return response;
  } else if (OrgName == "investor2") {
    response = await API.post(
      process.env.react_app_base_url + "backendapiwsfs/approveUser",
      data,
      { headers: headers }
    );
    return response;
  } else if (OrgName == "investor3") {
    response = await API.post(
      process.env.react_app_base_url + "backendapiwsfs/approveUser",
      data,
      { headers: headers }
    );
    return response;
  }
};

export const updateUser = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    platformname: determinePlatformName(),
    clientname: determinePlatformName(),
    channelname: ChannelName,
    clustertoken: `${token}`,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/updateApprovedUserProfileDetails",
    data,
    { headers: headers }
  );
  return response;
};


export const getDefinition = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/getDefinition?AssetType=" +
      data.AssetType +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

//Intain Admin Apis deal creation

export const getalldeals = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/getalldeals?UserID=" +
      data.UserID +
      "&peer=" +
      data.peer,
    { headers }
  );
  return response;
};

export const getallInvestors = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  }; 
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/getallInvestors?peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const getDealDetailsByPaymentDate = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };

  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/getDealDetailsByPaymentDate",
      data,
    { headers: headers }
  );
  return response;
};

// Loans Portfolio
export const GetDataByUpdateLoans = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/loan",
    data,
    { headers: headers }
  );
  return response;
};
export const GetDataByUpdateLoansDetails = async (data) => {
  const currentTheme =
    sessionStorage.getItem("dark-theme") === "dark" ? "dark" : "light";
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    Theme: currentTheme,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/loan_details_api",
    data,
    { headers: headers }
  );
  return response;
};

export const collateralDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/viewcollateralReport?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&Version=" +
      data.Version +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const BasicMapping = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/AutoMapping",
    data,
    { headers }
  );
  return response;
};

export const yamlIntellisense = async (data) => {
  const headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/YamlIntellisense?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&CurrentPaymentDate=" +
      data.CurrentPaymentDate +
      "&ClosingTape=" +
      data.ClosingTape +
      "&ServicerName=" +
      encodeURIComponent(data.ServicerName) +
      "&peer=" +
      data.peer +
      "&AssetType=" +
      data.assetType,
    { headers }
  );
  return response;
};


export const YamlConverter = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
  };
  
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/recurring/AIConvertor",
    data,
    { headers }
  );
  return response;
};

export const dealPreviewMapFieldsRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/loanTape",
    data,
    { headers: headers }
  );
  return response;
};

export const saveMappingsOrderList = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/saveMappingsOrderList",
    data,
    { headers }
  );
  return response;
};

export const PublishReport = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/recurring/publish",
    data,
    { headers: headers }
  );
  return response;
};

export const servicerGetalldeals = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/servicer/getalldeals?ServicerName=" +
      encodeURIComponent(data.ServicerName) +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const dealServicerViewDetails = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/dealservicerlist?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const dealCreationAddSave = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/savetableexp",
    data,
    { headers: headers }
  );
  return response;
};

export const dealCreationTable = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/viewtableexp?DealName=" +
      data.DealName +
      "&TableName=" +
      data.TableName +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const getPDFLogoData = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/viewpdflogo?ChannelName=" +
      data.ChannelName +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const dealCreation_BC_Status = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/bcstatus?DealName=" +
      data.DealName +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const dealCreationCreateUpdate = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/createupdate",
    data,
    { headers: headers }
  );
  return response;
};

export const dealCreationDelete = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/deletetableexp",
    data,
    { headers: headers }
  );
  return response;
};
export const dealCreationEdit = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/edittableexp",
    data,
    { headers: headers }
  );
  return response;
};

export const dealCreationSaveForNow = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/savefornow",
    data,
    { headers: headers }
  );
  return response;
};

export const dealCreationAutoSave = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/autosave",
    data,
    { headers: headers}
  );
  return response;
};

export const ViewAccountTable = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/viewaccounttable",
    data,
    { headers: headers}
  );
  return response;
};
export const ViewBorrowingTable = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/viewborrowingbasetable",
    data,
    { headers: headers}
  );
  return response;
};
export const savedealservicerdate = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/savedealservicerdate",
    data,
    { headers: headers}
  );
  return response;
};

export const PostPDFLogoData = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/uploadpdflogo",
    data,
    { headers: headers}
  );
  return response;
};

export const generatedealid = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/generatedealid?DealName=" +
      data.DealName +
      "&oldDealName=" +
      data.oldDealName +
      "&TableName=" +
      data.TableName +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const CloneDeal = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/cloneDeal",
    data,
    { headers }
  );
  return response;
};

export const checkDealName = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/dealcheck?DealName=" +
      data.DealName +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

//Intain Admin Apis Loan processing

export const SaveLoanProcessDate = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/saveloanprocessdate",
    data,
    { headers: headers }
  );
  return response;
};

export const ViewAggregateSummary = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/viewaggregatesummary?peer=" +
      data.peer +
      "&DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&ServicerName=" +
      encodeURIComponent(data.ServicerName),
    { headers: headers }
  );
  return response;
};

export const ConsolidatedAggregateSummaryToDB = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/consolidatedaggregatesummarytodb",
    data,
    { headers: headers }
  );
  return response;
};

export const ConsolidatedAggregateSummaryToBC = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/consolidatedaggregatesummarytobc",
    data,
    { headers: headers }
  );
  return response;
};

export const dealUploadLoanTape = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/UploadLoanTape",
    data,
    { headers: headers }
  );
  return response;
};

export const UploadClosingLoanTape = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/UploadClosingLoanTape",
    data,
    { headers: headers }
  );
  return response;
};

export const dealPreviewLoanTape = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/PreviewLoanTape1?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&ServicerName=" +
      encodeURIComponent(data.ServicerName) +
      "&ClosingTape=" +
      data.ClosingTape +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const StdfieldsQuery = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/StdfieldsQuery?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&ServicerName=" +
      encodeURIComponent(data.ServicerName) +
      "&ClosingTape=" +
      data.ClosingTape +
      "&peer=" +
      data.peer +
      "&AssetType=" +
      data.AssetType,
    { headers: headers }
  );
  return response;
};

export const getMapping = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/getMapping?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&ServicerName=" +
      encodeURIComponent(data.ServicerName) +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

  export const getClosingTapeMapping = async (data) => {
    let headers = {
      authorization: `Bearer ${jwtToken}`,
      clientname: determinePlatformName(),
      clustertoken: `${token}`,
      platformname: determinePlatformName(),
      channelname: ChannelName,
    };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/getClosingTapeMapping?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&ServicerName=" +
      encodeURIComponent(data.ServicerName) +
      "&ClosingTape=" +
      data.ClosingTape +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const saveMapping = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/saveMapping",
    data,
    { headers: headers }
  );
  return response;
};

export const dealPreviewMapFields = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/PreviewMappedFields?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&ServicerName=" +
      encodeURIComponent(data.ServicerName) +
      "&ClosingTape=" +
      data.ClosingTape +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const Summarize = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/summarize",
    data,
    { headers: headers }
  );
  return response;
};

export const SaveAggregateSummaryToBC = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/saveaggregatesummarytobc",
    data,
    { headers: headers }
  );
  return response;
};

//-------------------------------------------------------------- recurring --------------------------------------------------//

export const generalOnPageReload = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/recurring",
    data,
    { headers: headers }
  );
  return response;
};

  export const getDealDetailsByDealName = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/investor/getDealDetailsByDealName?DealName=" +
      data.DealName +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};
// export const generalDealRecurring = async (data) => {
// 	const response = await API.post(process.env.react_app_base_url + 'backendapiwsfs/trustee/recurring/general',data,{ headers: {"authorization" : `Bearer ${token}`} })
// 	return response;
// };

export const DealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&TableName=" +
      data.TableName +
      "&Version=" +
      data.Version +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const ModifiedDateRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/modifieddate?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&peer=" +
      data.peer +
      "&OrgName=" +
      data.OrgName,
    { headers: headers }
  );
  return response;
};
export const InvestorReportData = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/invreport?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&NextPaymentDate=" +
      data.NextPaymentDate +
      "&peer=" +
      data.peer,
      { headers: headers }
  );
  return response;
};

export const getDealDetailsByInvestorPaymentDate = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/investor/getDealDetailsByPaymentDate",
    data,
    { headers: headers }
  );
  return response;
};
export const tranchesGetDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/tranchetxn?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&TableName=" +
      data.TableName +
      "&Version=" +
      data.Version +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};
export const getIndexDealRecurring = async (data) => {  
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/tranches?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&TableName=" +
      data.TableName +
      "&Version=" +
      data.Version +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};
export const CalculatePayments = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/calculatepayments",
    data,
    { headers: headers }
  );
  return response;
};

export const CalculateCollateralPayments = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/collateralReport",
    data,
    { headers: headers }
  );
  return response;
};

export const CalculateConsolidatedPayments = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/consolidatedReport",
    data,
    { headers: headers }
  );
  return response;
};

export const CalculatePrePayments = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/prepayment",
    data,
    { headers: headers }
  );
  return response;
};

export const CalculateESMAPayments = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/EsmaReport",
    data,
    { headers: headers }
  );
  return response;
};

export const ViewConsolidatedReport = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/viewconsolidatedReport?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&Version=" +
      data.Version +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const getAllVersionsByPaymentDate = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/getAllVersionsByPaymentDate?DealName=" +
      data.DealName +
      "&selectedDate=" +
      data.selectedDate +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const getAllPaymentDatesByDealName = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/getAllPaymentDatesandVersionsByDealName?DealName=" +
      data.DealName +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const FilesAddDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/addDealDocument",
    data,
    { headers: headers }
  );
  return response;
};
export const FilesRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/viewDealDocument?DealName=" +
      data.DealName +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const DownloadRowClick = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/downloadDealDocument?documentID=" +
      data.documentID +
      "&peer=" +
      data.peer,
    {
      headers: headers,
      responseType: "arraybuffer", // Add this line to request binary data
    }
  );
  return response;
};

export const DownloadExcel = async (data) => {
  const response = await API.post(
    "downloadconsolidatedloantape",
    { file: data.file, file2: data.file2 },
    {
      responseType: "arraybuffer",
      validateStatus: (status) =>
        status === 200 || status === 202 || status === 404,
    }
  );
  return response;
};

export const tranchesDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/tranches",
    data,
    { headers: headers }
  );
  return response;
};

export const feesDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/recurring/fees",
    data,
    { headers: headers }
  );
  return response;
};

export const expensesDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/expenses",
    data,
    { headers: headers }
  );
  return response;
};

export const editexpensesDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/editexpenses",
    data,
    { headers: headers }
  );
  return response;
};
export const editmanualinputRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/editManualInputs",
    data,
    { headers: headers }
  );
  return response;
};

export const testsDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/trustee/recurring/tests",
    data,
    { headers: headers }
  );
  return response;
};

export const variablesDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/variables",
    data,
    { headers: headers }
  );
  return response;
};

export const accountsDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/accounts",
    data,
    { headers: headers }
  );
  return response;
};

export const addtransactionDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/addtransaction",
    data,
    { headers: headers }
  );
  return response;
};

export const deletetransactionDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/deletetransaction",
    data,
    { headers: headers }
  );
  return response;
};

export const editTranchestransactionDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/edittranchetransaction",
    data,
    { headers: headers }
  );
  return response;
};

export const deleteTranchestransactionDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/deletetranchetransaction",
    data,
    { headers: headers }
  );
  return response;
};

export const addtransactionTranchesRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/addtranchetransaction",
    data,
    { headers: headers }
  );
  return response;
};

export const edittransactionDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/edittransaction",
    data,
    { headers: headers }
  );
  return response;
};

export const paymentrulesDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/paymentrules",
    data,
    { headers: headers }
  );
  return response;
};

export const calculatepaymentsDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/calculatepayments",
    data,
    { headers: headers }
  );
  return response;
};

export const generatereportDealRecurring = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/recurring/generatereport",
    data,
    { headers: headers }
  );
  return response;
};

export const exportAsPDF = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/invreportpdf",
    data,
    { headers: headers }
  );
  return response;
};

// STD Fields
export const getdefinition = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/trustee/getdefinition?AssetType=" +
      data.AssetType +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};
export const deletedefinition = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/deletedefinition",
    data,
    { headers: headers }
  );
  return response;
};
export const updatedefinition = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/updatedefinition",
    data,
    { headers: headers }
  );
  return response;
};

//-------------------------------------------------------------- Investor Dashboard --------------------------------------------------//

export const investorGetalldeals = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/investor/getalldeals?InvID=" +
      data.InvID +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

export const months = [
  {
    value: "1",
    label: "January",
  },
  {
    value: "2",
    label: "February",
  },
  {
    value: "3",
    label: "March",
  },
  {
    value: "4",
    label: "April",
  },
  {
    value: "5",
    label: "May",
  },
  {
    value: "6",
    label: "June",
  },
  {
    value: "7",
    label: "July",
  },
  {
    value: "8",
    label: "August",
  },
  {
    value: "9",
    label: "September",
  },
  {
    value: "10",
    label: "October",
  },
  {
    value: "11",
    label: "November",
  },
  {
    value: "12",
    label: "December",
  },
];

export function generateYears() {
  let min = 2010;
  console.log("min", min);
  let max = new Date().getFullYear();
  console.log("max", max);
  let years = [];
  for (var i = min; i <= max; i++) {
    console.log("asdasd", i);
    years.push({
      value: i.toString(),
      label: i.toString(),
    });
  }
  let reversarray = years.reverse();
  return reversarray;
}

// For Portfolio

export const GetDataByDefaultValue = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/defaultvalue",
    data,
    { headers: headers }
  );
  return response;
};

export const GetDataByUpdateAsset = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/updateasset",
    data,
    { headers: headers }
  );
  return response;
};
export const GetDataByUpdateIssuer = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/updateissuer",
    data,
    { headers: headers }
  );
  return response;
};
export const GetDataByTableChartData = async (data) => {
  const currentTheme =
    sessionStorage.getItem("dark-theme") === "dark" ? "dark" : "light";
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    Theme: currentTheme ,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/portfolio",
    data,
    { headers: headers }
  );
  return response;
};

// Deal Portfolio
export const GetDataByTableChartDataDeal = async (data) => {
  const currentTheme =
    sessionStorage.getItem("dark-theme") === "dark" ? "dark" : "light";
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    Theme: currentTheme ,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/deal",
    data,
    { headers: headers }
  );
  return response;
};

// Deal Portfolio
export const GetDataByTableChartDataTile = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/tile",
    data,
    { headers: headers }
  );
  return response;
};

export const GetDataByTableChartFundingDeal = async (data) => {
  const currentTheme =
    sessionStorage.getItem("dark-theme") === "dark" ? "dark" : "light";
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
     platformname : determinePlatformName(),
    channelname : ChannelName,
    Theme: currentTheme
  };

  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/funding",
    data,
    {
      headers: headers
    }
  );

  return response;
};

export const GetDataByPaymentDatesDeal = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/paymentdates",
    data,
    { headers: headers }
  );
  return response;
};

// Start of Strats Filters

export const fetchPaymentDateFilters = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/getPaymentDates",
    data,
    { headers: headers }
  );
  return response;
};
export const fetchPrimaryStartFilters = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/stratsFilter?dealId=" +
      data.dealId +
     "&date=" +
      data.date,
    { headers: headers }
  );
  return response;
};

// export const fetchSecondaryStartFilters = async (data) => {
export const ViewStratsTab = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/stratsTable",
    data,
    { headers: headers }
  );
  return response;
};
//   const response = await API.post(
//     "https://www.ask.intainabs.com/stratsSecFilter",
//     data,
//     { headers: headers }
//   );
//   return response;
// };
// export const fetchTertiaryStartFilters = async (data) => {
//   const response = await API.post(
//     "https://www.ask.intainabs.com/stratsTertiaryFilter",
//     data,
//     { headers: headers }
//   );
//   return response;
// };

export const FilterDataOnFilteredResults = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/combinedResults",
    data,
    { headers: headers }
  );
  return response;
};

export const GetDataByDefaultInputs = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/defaultInputs",
    data,
    { headers: headers }
  );
  return response;
};

export const fetchPerformanceFilters = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
     platformname : determinePlatformName(),
    channelname : ChannelName,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
  };
  const response = await API.get(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/performanceFilters",
    {
      headers: headers,
      params: data,
    }
  );
  return response;
};

export const GetVintageData = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname : ChannelName,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/vintage",
    data,
    { headers: headers }
  );
  return response;
};

//---------------------------ESMA----------------------//

export const ViewEsmaReport = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/recurring/viewesmaReport?DealName=" +
      data.DealName +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&Version=" +
      data.Version +
      "&peer=" +
      data.peer,
    { headers: headers }
  );
  return response;
};

//------------------------Servicer Changes API --------------------------------\\

export const QueryDatatapes = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/QueryDatatapes?DealName=" +
      data.DealName +
      "&peer=" +
      data.peer +
      "&ServicerName=" +
      encodeURIComponent(data.ServicerName),
    { headers: headers }
  );
  return response;
};

export const dealUploadLoanTapeprocessing = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url + "backendapiwsfs/UploadLoanTapeProcessing",
    data,
    { headers: headers }
  );
  console.log("servicerjs", response);
  return response;
};

export const getDealDetailsByPaymentDateservicer = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    process.env.react_app_base_url +
      "backendapiwsfs/servicer/getDealDetailsByPaymentDate",
    data,
    { headers: headers }
  );
  return response;
};

// ----------------------------Annex XML Download-----------------------------------\\


export const generateAnnex2XML = async(data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
  process.env.react_app_base_url +
  "backendapiwsfs/generateAnnex2XML?DealName=" +
  data.DealName +
  "&Month=" +
  data.Month +
  "&Year=" +
  data.Year +
  "&Version=" +
  data.Version +
  "&peer=" +
  data.peer,
  
  { headers: headers }
  );
  return response;
  }

export const generateAnnex12XML = async(data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
  process.env.react_app_base_url +
  "backendapiwsfs/generateAnnex12XML?DealName=" +
  data.DealName +
  "&Month=" +
  data.Month +
  "&Year=" +
  data.Year +
  "&Version=" +
  data.Version +
  "&peer=" +
  data.peer,
  { headers: headers }
  );
  return response;
  }

export const generateAnnex14XML = async(data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
  process.env.react_app_base_url +
  "backendapiwsfs/generateAnnex14XML?DealName=" +
  data.DealName +
  "&Month=" +
  data.Month +
  "&Year=" +
  data.Year +
  "&Version=" +
  data.Version +
  "&peer=" +
  data.peer,
  { headers: headers }
  );
  return response;
  }
  
  export const download2XML = async (data) => {
    let headers = {
      authorization: `Bearer ${jwtToken}`,
      clientname: determinePlatformName(),
      clustertoken: `${token}`,
      platformname: determinePlatformName(),
      channelname: ChannelName,
    };
    const annex2file = `Annex2-${data.DealName}-${data.Month}-${data.Year}.xml`; // Updated file format
    const response = await API.get(
      `${process.env.react_app_base_url}backendapiwsfs/downloadXML?file=${annex2file}`,
      { headers: headers }
    );
    return response;
  };

  export const downloadEsmaReport = async (data) => {
    const response = await API.post(
      "downloadesmareport",
      { file: data.file },
      {
        responseType: "arraybuffer",
        validateStatus: (status) =>
          status === 200 || status === 202 || status === 404,
      }
    );
    return response;
  };
  
  
  export const download12XML = async (data) => {
    let headers = {
      authorization: `Bearer ${jwtToken}`,
      clientname: determinePlatformName(),
      clustertoken: `${token}`,
      platformname: determinePlatformName(),
      channelname: ChannelName,
    };
    const annex12file = `Annex12-${data.DealName}-${data.Month}-${data.Year}.xml`;
    const response = await API.get(
      `${process.env.react_app_base_url}backendapiwsfs/downloadXML?file=${annex12file}`,
      { headers: headers }
    );
    return response;
  };
  export const download14XML = async (data) => {
    let headers = {
      authorization: `Bearer ${jwtToken}`,
      clientname: determinePlatformName(),
      clustertoken: `${token}`,
      platformname: determinePlatformName(),
      channelname: ChannelName,
    };
    const annex14file = `Annex14-${data.DealName}-${data.Month}-${data.Year}.xml`;
    const response = await API.get(
      `${process.env.react_app_base_url}backendapiwsfs/downloadXML?file=${annex14file}`,
      { headers: headers }
    );
    return response;
  };
  

   // -----------------------------Clone From Existing Deal for Loan Tape Map Fields and Closing Loan Tape Map Fields-----------------------------------\\

 export const getExistingDeals = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/existingDealsList?Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&peer=" +
      data.peer,
    { headers }
  );
  return response;
};

export const CloneFromExistingDeal = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/CloneFromExistingDeal?DealName=" +
      data.DealName +
      "&ServicerName=" +
      encodeURIComponent(data.ServicerName) +
      "&Month=" +
      data.Month +
      "&Year=" +
      data.Year+
      "&peer=" +
      data.peer ,
    { headers }
  );
  return response;
};
export const getClosingExistingDeals = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/existingClosingTapeDealsList?Month=" +
      data.Month +
      "&Year=" +
      data.Year +
      "&peer=" +
      data.peer,
    { headers }
  );
  return response;
};

export const CloneFromExistingDealClosing = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    process.env.react_app_base_url +
      "backendapiwsfs/cloneFromExistingClosingDeal?DealName=" +
      data.DealName +
      "&peer=" +
      data.peer ,
    { headers }
  );
  return response;
};

// Newly Added Strats Implementation from CF

export const fetchAdditionalColumnsFilters = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/additionalColumnsStrats?dealId=" +
      data.dealId +
      "&date=" +
      data.date,
    { headers: headers }
  );
  return response;
};

export const fetchVintageFilters = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/vintageFilter?dealId="+
    data.dealId,
    { headers: headers }
  );
  return response;
};

// Modal Representation Api

export const DataSourceName = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.get(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/dataSourceColumns?dealId="+data.dealId+"&date="+data.date+"&dataSourceName="+data.dataSourceName,
    { headers: headers }
  );
  return response;
};

export const plotDataSourceCharts = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/dataSource",
    data,
    { headers: headers }
  );
  return response;
};

// Stratification Api

export const getstratifications = async (data) => {
  try {
    const headers = {
      Authorization: `Bearer ${jwtToken}`, // Capitalized header name per convention
      clientname: determinePlatformName(),
      clustertoken: `${token}`,
      platformname: determinePlatformName(),
      channelName: ChannelName,
    };

    const response = await API.post(
      "https://analytics.wsfs.intainabs.com/wsfsdashboard/getstratifications", 
      data,
      { headers }
    );

    return response;
  } catch (error) {
    // Handle error appropriately
    console.error('Error fetching stratifications:', error);
    throw error; // Re-throw to let caller handle it
  }
};


// Strats Field List API
export const getStratsFieldList = async (data) => {
  try {
    const headers = {
      Authorization: `Bearer ${jwtToken}`,
      platformName: determinePlatformName(),
      channelName: ChannelName,
      clientName: determinePlatformName(),
      clustertoken:`${token}`
    };

    const response = await API.post(
      "https://analytics.wsfs.intainabs.com/wsfsdashboard/strats_field_list",
      data,
      { headers }
    );

    return response;
  } catch (error) {
    console.error("Error fetching strats field list:", error);
    throw error;
  }
};

export const saveCollateralReportConfig = async (data) => {
  try {
    const headers = buildAskStratHeaders();
    const base = getAskAiBaseUrl();
    return await API.post(`${base}wsfsdashboard/save_collateral_report_config`, data, {
      headers,
    });
  } catch (error) {
    console.error("Error saving collateral report config:", error);
    throw error;
  }
};

// Direct AI summarization endpoint (external)
export const SummarizePortfolioAI = async (data) => {
  const response = await axios.post(
    "https://ai.intainabs.com/summarize",
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};

// IDA: Fetch deal documents for Document mode
export const getDealDocuments = async (dealId) => {
  const response = await axios.get(
    `https://ai.intainabs.com/ida2/deal-documents/${dealId}`
  );
  return response;
};


// New changes

// Newly Added Strats & Performance Graphs Implementation from CF

export const GetDataByStratsGraph = async (data) => {
  const currentTheme =
    sessionStorage.getItem("dark-theme") === "dark" ? "dark" : "light";
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
    Theme: currentTheme,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/stratsGraph",
    data,
    { headers }
  );
  return response;
};


// Performance Graphs
export const GetDataByPerformanceGraph = async (data) => {
  const currentTheme =
    sessionStorage.getItem("dark-theme") === "dark" ? "dark" : "light";
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
    Theme: currentTheme,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/performanceGraph",
    data,
    { headers }
  );
  return response;
};

// Add Risk Overview Tab APIs

export const GetDataByCovenants = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
     platformname : determinePlatformName(),
    channelname : ChannelName,
    clientname:determinePlatformName(), 
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/covenants",
    data,
    { headers: headers }
  );
  return response;
};

export const GetDataByTriggers = async (data) => {
  const currentTheme =
    sessionStorage.getItem("dark-theme") === "dark" ? "dark" : "light";
  let headers = {
    authorization: `Bearer ${token}`,
     platformname : determinePlatformName(),
    channelname : ChannelName,
    clientname:determinePlatformName(), 
    Theme: currentTheme,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/triggers",
    data,
    { headers: headers }
  );
  return response;
};

export const GetDataByConcentration = async (data) => {
  const currentTheme =
    sessionStorage.getItem("dark-theme") === "dark" ? "dark" : "light";
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
    Theme: currentTheme,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/concentration",
    data,
    { headers }
  );
  return response;
};

// Widget Dashboard Apis

export const calculateChartData = async (payload) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
  };
  try {
    console.log("Sending chart data request:", {
      url: "https://www.ask.intainabs.com/snowdynamicdashboard/calculatedata",
      payload,
      headers,
    });
    const response = await API.post(
      "https://www.ask.intainabs.com/snowdynamicdashboard/calculatedata",
      payload,
      { headers }
    );
    console.log("Chart data response:", response);

    if (response.data && response.data.option) {
      // Ensure the response data has the correct structure
      const option = response.data.option;
      if (!option.data || !Array.isArray(option.data)) {
        option.data = [];
      }
      if (!option.layout) {
        option.layout = {};
      }
      response.data.option = option;
    }

    return response;
  } catch (error) {
    console.error("Error calculating chart data:", error);
    throw error;
  }
};

export const getDashboardPlots = async (userId,screen) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
  };
  const response = await API.get(
    `https://www.ask.intainabs.com/snowdynamicdashboard/getdashboard?userid=${userId}&screen=${screen}`,
    { headers }
  );
  return response;
};



export const getDynamicTableResponse = async (tableName) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
  };  
  const response = await API.get(
    `https://www.ask.intainabs.com/snowdynamicdashboard/gettablecolumns?tablename=${tableName}`,
    { headers }
  );
  console.log({ response });
  return response;
};


export const getKpiSummary = async (userId) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/kpiSummary",
    userId,
    { headers }
  );
  return response;
};

export const getCapitalStructures = async (payload) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/capitalStructures",
    payload,
    { headers }
  );
  return response;
};

export const getUserdeals = async (userId) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
  };
  const response = await API.get(
    `https://www.ask.intainabs.com/snowdynamicdashboard/getuserdeals?userid=${userId}`,
    { headers }
  );
  return response;
};

export const save_plots = async (data) => {
  let headers = {
    authorization: `Bearer ${token}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),  
  };
  const response = await API.post(
    "https://www.ask.intainabs.com/snowdynamicdashboard/save_dashboard",
    data,
    { headers }
  );
  return response;
};

export const GetDataByTableChartPaymentWF = async (data) => {
  const currentTheme =
    sessionStorage.getItem("dark-theme") === "dark" ? "dark" : "light";
  let headers = {
    authorization: `Bearer ${token}`,
     platformname : determinePlatformName(),
    channelname : ChannelName,
    Theme: currentTheme,
    clientname:determinePlatformName(), 
  };

  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/paymentWaterfall",
    data,
    {
      headers: headers
    }
  );

  return response;
};


export const fetchRollrateFilters = async () => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
  };
  const response = await API.get(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/rollrateFilters",
    { headers: headers }
  );
  return response;
};

export const fetchRollrateData = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/rollrate",
    data,
    { headers: headers }
  );
  return response;
};

export const fetchRollrateTile = async (data) => {
  let headers = {
    authorization: `Bearer ${jwtToken}`,
    platformname: determinePlatformName(),
    channelname: ChannelName,
    clientname: determinePlatformName(),
    clustertoken: `${token}`,
  };
  const response = await API.post(
    "https://analytics.wsfs.intainabs.com/wsfsdashboard/rollrateTile",
    data,
    { headers: headers }
  );
  return response;
};